import React from "react";
import { TextInput } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { getOrderPolicyNumberLabel } from "../helpers/orderProductUtils";
import { omitFormRenderContext } from "../helpers/omitFormRenderContext";

const OrderPolicyNumberInput = ({ form, label, ...props }) => {
  const { t } = useTranslation();
  return (
    <TextInput
      {...omitFormRenderContext(props)}
      label={t(getOrderPolicyNumberLabel(form?.values))}
    />
  );
};

export default OrderPolicyNumberInput;
